module.exports = __webpack_public_path__ + "static/media/youtube.c2b11dc8.jpg";